import React from 'react';
import Button from '@mui/material/Button';
import { PURPLE, RADII } from './theme.js';

const PURPLE_HOVER = '#3F1C84';

export function CtaButton({ href, children, sx, ...props }) {
    return (
        <Button
            {...props}
            variant="contained"
            href={href}
            component="a"
            sx={{
                background: PURPLE,
                px: 3,
                py: 1.5,
                fontWeight: 700,
                fontSize: 15,
                textTransform: 'none',
                borderRadius: RADII.sm,
                boxShadow: '0 14px 30px -10px rgba(81,36,166,0.55)',
                '&:hover': {
                    background: PURPLE_HOVER,
                    transform: 'translateY(-2px)',
                    boxShadow: '0 16px 34px -10px rgba(81,36,166,0.6)',
                },
                ...sx,
            }}
        >
            {children}
        </Button>
    );
}
